module.exports = __webpack_public_path__ + "img/grid-2.dee0afd1.svg";